/**
 * Self-service onboarding routes.
 *
 * /get-started            → create-account screen (AuthLayout shell)
 * /get-started/password   → set-password step of the email signup
 * /get-started/setup      → redirects to the first wizard step
 * /get-started/setup/:id  → "Create workspace" wizard step
 *
 * Always registered; each page is wrapped in `SelfServiceGate`, which reads
 * the server-driven gate (`/api/waitlist/self-service/status/`) and falls
 * through to the login redirect when the flow is disabled.
 */
import { Navigate } from 'react-router-dom';

import {
  FIRST_STEP_PATH,
  GET_STARTED_PATH,
  SET_PASSWORD_PATH,
  SETUP_BASE_PATH,
} from '@/lib/self-service/constants';
import GetStartedPage from '@/pages/get-started/GetStartedPage';
import SetPasswordPage from '@/pages/get-started/SetPasswordPage';
import SetupPage from '@/pages/get-started/SetupPage';

export const getStartedRoutes = [
  {
    path: GET_STARTED_PATH,
    element: <GetStartedPage />,
  },
  {
    path: SET_PASSWORD_PATH,
    element: <SetPasswordPage />,
  },
  {
    path: SETUP_BASE_PATH,
    element: <Navigate to={FIRST_STEP_PATH} replace />,
  },
  {
    path: `${SETUP_BASE_PATH}/:stepId`,
    element: <SetupPage />,
  },
];
